// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__1YD0K","icon":"style_icon__1j6YG","setIcon":"style_setIcon__2Gtkz","setIconActive":"style_setIconActive__1CI7r","link":"style_link__3npyx"};